import React from 'react';
import * as FaIcons from 'react-icons/fa';
import Button from '..';

export default function IconButton({
  icon,
  color = '#fff',
  variant,
  size = 16,
  sizeButton = 'sm',
  loading,
  onClick,
  disabled,
  ...props
}) {
  const Icon = FaIcons[icon] || FaIcons.FaQuestionCircle;

  return (
    <Button
      {...props}
      variant={variant}
      onClick={onClick}
      loading={loading}
      size={sizeButton}
      disabled={disabled}
    >
      <Icon color={color} size={size} style={{ marginBottom: 3 }} />
    </Button>
  );
}
